module.exports = __webpack_public_path__ + "img/eliminartunay.12d43967.png";